import { API_HOST } from '../../config';
import getEventFrame from '../../lib/get-event-frame';
import { ApplePayParams, EmptyCb } from '../../types';
import { isFrameStartApplePayMessage } from '../../utils/common';
import { getPaymentMessage } from '../../utils/message';

import { beginApplePaySession } from './begin-apple-pay-session';
import { FrameApplePayOutgoingMessage } from './frame-apple-pay-message';

export const applePay = ({
    apiHost = API_HOST,
    frameOrigin = API_HOST,
    onSendResponse,
}: ApplePayParams = {}): EmptyCb => {
    const handlePostMessage = (e: MessageEvent): void => {
        const message = getPaymentMessage(e.data);

        if (isFrameStartApplePayMessage(message)) {
            const { request, merchantId, purchaseToken } = message.data;

            const handleSendResponse =
                onSendResponse ||
                ((m: FrameApplePayOutgoingMessage) => {
                    const iframe = getEventFrame(e);

                    iframe?.contentWindow?.postMessage(m, frameOrigin);
                });

            beginApplePaySession({
                request,
                merchantId,
                purchaseToken,
                apiHost,
                onSendResponse: handleSendResponse,
            });
        }
    };

    window.addEventListener('message', handlePostMessage);

    return (): void => {
        window.removeEventListener('message', handlePostMessage);
    };
};
